import styled from "styled-components";

const getStatusColor = (percentage: number) => {
    if (percentage >= 95) return "#D90429";
    if (percentage >= 80) return "#FFBE0B";
    return "#2E933C";
};

const ProgressBarContainer = styled.div`
    width: 130px;
    height: 8px;
    background-color: #333;
    border-radius: 5px;
    overflow: hidden;
    margin: 4px auto;
`;

const ProgressBarFill = styled.div<{ $percent: number }>`
    width: ${props => props.$percent}%;
    height: 100%;
    background-color: ${props => getStatusColor(props.$percent)};
    transition: width 0.5s ease-in-out;
`;

export const ProgressBar = ({ occupied, total }: { occupied: number, total: number }) => {

    const percent = (occupied / total) * 100;
    
    return (
        <div>
            {/* <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>{occupied} / {total}</span>
                <strong>{percent.toFixed(1)}%</strong>
            </div> */}
            <ProgressBarContainer>
                <ProgressBarFill $percent={percent} />
            </ProgressBarContainer>
        </div>
    );
};